/**
 * @fileoverview Admin dashboard index route
 * @module routes/sys/mgmt/$segment/index
 */

import type { ReactElement } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AdminDashboard } from '@/features/admin';

/**
 * Search params schema for admin dashboard.
 */
const adminSearchSchema = z.object({
  tab: z.enum(['projects', 'kol-applications', 'approved-kols']).optional(),
});

/**
 * Admin dashboard index route.
 *
 * Renders the main admin dashboard with project and KOL application lists.
 * This is the default route when accessing /sys/mgmt/$segment
 *
 * @component
 */
function AdminDashboardRoute(): ReactElement {
  const { tab } = Route.useSearch();
  return <AdminDashboard initialTab={tab} />;
}

/**
 * File-based route configuration.
 *
 * Creates route: /sys/mgmt/$segment/ (index)
 */
export const Route = createFileRoute('/sys/mgmt/$segment/')({
  component: AdminDashboardRoute,
  validateSearch: adminSearchSchema,
});
